import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import MessageCollection from 'collections/message';
import Appointment from 'models/appointment';


export default Backbone.View.extend({
  initialize: function (options) {
    _.bindAll(this, 'decline_appointment', 'confirm_appointment',
      'delete_appointment', 'respond_appointment', 'render_appointment',
      'render_appointment_event', 'update_messages');

    this.template = _.template($('#appt-modal-guts-tmpl').html());
    this.msg_collection = options.msg_collection;

    // Turn off any events related to a different coach
    this.$el.off('show.bs.modal');
    this.$el.off('click', 'a.decline');
    this.$el.off('click', 'a.confirm');

    // Set our own events
    this.$el.on('show.bs.modal', this.render_appointment_event);
    this.$el.on('click', 'a.decline', this.decline_appointment);
    this.$el.on('click', 'a.confirm', this.confirm_appointment);
    this.$el.on('click', 'a.delete', this.delete_appointment);
  },

  render_appointment_event: function (e) {
    // Get appointment url from the modal trigger
    var url = $(e.relatedTarget).attr('data-url');
    this.render_appointment(url);
  },

  render_appointment: function (msg_url) {
    // Find a message containing the appointment details
    var message = this.msg_collection.findWhere({ url: msg_url });
    $('#appt-content', this.$el).html(this.template({ message: message }));
  },

  decline_appointment: function (e) {
    this.respond_appointment(e, 'reject');
  },

  confirm_appointment: function (e) {
    this.respond_appointment(e, 'confirm');
  },

  delete_appointment: function (e) {
    this.respond_appointment(e, 'delete');
  },

  respond_appointment: function (e, response) {
    e.preventDefault();
    e.stopPropagation();

    var url = $(e.currentTarget).attr('data-url');

    var msg = this.msg_collection.find(function (item) {
      return item.get('appointment') && item.get('appointment').url === url;
    });
    var appt = new Appointment(msg.get('appointment'), { parse: true });

    if (response == 'delete') {
      var that = this;
      appt.destroy({ success: function (data) {
        data.set('status', 'deleted');
        that.update_messages(data);
      } });
    } else {
      appt.save({ response: response }, { success: this.update_messages });
    }
  },

  update_messages: function (data) {

    // Get the messages that reference this appt
    var msgs = this.msg_collection.filter(function (item) {
      return item.get('appointment') && item.get('appointment').url === data.url();
    });

    // Update the msgs with the new appt
    _.each(msgs, function (msg) {
      msg.set({ appointment: data.toJSON() });
    });

    // Update the modal if it is open
    if (this.$el.data('bs.modal').isShown) {
      this.render_appointment(msgs[0].id);
    }
  }

});



// WEBPACK FOOTER //
// ./static/js/views/appointment.js